// extracted by mini-css-extract-plugin
export default {"container":"CompleteVerifyContent_container__4+tP2","message":"CompleteVerifyContent_message__HCSGB"};